const buttonClasses = 'bg-accent-600 text-black';

const buttonHoverClasses = 'hover:bg-accent-900';

const buttonIconClasses = 'fill-black';

const buttonAccentClasses = { buttonBlogVariantClasses: [buttonClasses, buttonHoverClasses], buttonIconClasses };

export default buttonAccentClasses;
